import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Layout from "../../components/layout/Layout";

/**
 * Renders a dashboard component with a centered image inside a grid container.
 */
function Dashboard() {
  return (
    <Layout>
      {/* Main Content Grid */}
      <Grid container direction="column" alignContent="center" justifyContent="center" sx={{ width: "100%" }} my={8}>
        <Grid sx={{ width: "80%", my: 2 }}>
          <Box
            width={"100%"}
            component="img"
            src={"https://data-engineering-public-bucket.s3.eu-west-2.amazonaws.com/dashboard-cover.jpg"}
          ></Box>
        </Grid>
      </Grid>
    </Layout>
  );
}

export default Dashboard;
